export const SET_MORE = (state, value) => {
  state.more = value
}

export const SET_LIMIT = (state, value) => {
  state.limit = value
}

export const SET_SORT = (state, value) => {
  state.sort = value
}

export const SET_SEARCHING = (state, value) => {
  state.searching = value
}

export const SET_SEARCHED = (state, value) => {
  state.searched = value
}
